import request from '@/utils/request'

// 查询省，市，区
export function findCfgCantonlist(upcode, cantonlevel) {
    return request({
        url: `/case/findCfgCantonlist/${upcode}/${cantonlevel}`,
        method: "get"
    });
}

// 获取数据字典
export function findDdItmeByCharsCrm(data) {
    return request({
        url: `/msg/findDdItmeByChars`,
        method: "post",
        data
    });
}